<template>
  <span class="count-badge">
    {{ value }}
  </span>
</template>

<script setup lang="ts">
export type CountBadgeProps = {
  value: number;
};

const props = withDefaults(defineProps<CountBadgeProps>(), {});
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.count-badge {
  font-size: calculate-rem(12px);
  display: block;
  background-color: var(--badge-color, var(--color-success));
  color: var(--color-inverse-font);
  min-width: 18px;
  height: 18px;
  line-height: 18px;
  padding: 0 4px;
  border-radius: 9px;
  text-align: center;
  font-weight: 700;
}
</style>
